import FilterItemsField from "./FilterItemsField";
import FilterContextField from "./FilterContextField";
import FilterItemsContextField from "./FilterItemsContextField";

const Fields = {
    Items: FilterItemsField,
    Context: FilterContextField,
    ItemsContext: FilterItemsContextField
};
export default Fields;
